export const headerLanguages = {
  English: {
    title: "Weather App",
    direction: "ltr",
    menus: {
      home: "Home",
      api: "API",
    },
  },
  Persian: {
    title: "اَپ آب و هوا",
    direction: "rtl",
    menus: {
      home: "خانه",
      api: "ای پی آی",
    },
  },
};

export const homeLanguages = {
  English: {
    searchTitle: "Search for latest weather updates",
    submit: "Get Weather",
    style: {
      dir: "ltr",
      borderRadiusSubmit: {
        borderTopRightRadius: "0.5rem",
        borderBottomRightRadius: "0.5rem",
      },
      borderRadiusField: {
        borderTopLeftRadius: "0.5rem",
        borderBottomLeftRadius: "0.5rem",
      },
    },
  },
  Persian: {
    searchTitle: "آخرین تغییرات آب و هوایی رو جست و جو کن",
    submit: "دریافت آب و هوا",
    style: {
      dir: "rtl",
      borderRadiusSubmit: {
        borderTopLeftRadius: "0.5rem",
        borderBottomLeftRadius: "0.5rem",
      },
      borderRadiusField: {
        borderTopRightRadius: "0.5rem",
        borderBottomRightRadius: "0.5rem",
      },
    },
  },
};

export const weatherLangs = {
  English: {
    mainTitle: {
      normal: "Weather",
      bold: "Forecast",
    },
    leading: "Select worlds leading cities:",
    week: "Week",
    style: {
      dir: "ltr",
    },
    today: "Today",
    humidity: "Humidity:",
    dewPoint: "Dew point:",
    feelsLike: "Feels like:",
    popup: {
      saved: "Successfully saved",
      notSaved: "current city is already saved!",
      delete: "Successfully  deleted",
      notDeleted: "Current city is already deleted!",
    },
  },
  Persian: {
    mainTitle: {
      normal: "پیش بینی",
      bold: "آب و هوا",
    },
    leading: "انتخاب شهرهای برتر جهان",
    week: "هفته",
    style: {
      dir: "rtl",
    },
    today: "امروز",
    humidity: "رطوبت:",
    dewPoint: "نقطه شبنم:",
    feelsLike: "حس دمایی:",
    popup: {
      saved: "با موفقیت ذخیره شد",
      notSaved: "شهر فعلی قبلا ذخیره شده است!",
      delete: "با موفقیت پاک شد",
      notDeleted: "شهر فعلی قبلا پاک شده است",
    },
  },
};
